<ng-container *ngIf="(results | async)?.length">
  <div class="call-layout header-text">
    <div translate>INBOUND_DASHBOARD.CLIENT_PHONE</div>
    <div translate>INBOUND_DASHBOARD.YOUR_PHONE</div>
    <div translate>INBOUND_DASHBOARD.WAIT_TIME</div>
  </div>
  <div class="call-layout" *ngFor="let item of results | async">
    <cc-msisdn [msisdn]="item.sourceMsisdn"></cc-msisdn>
    <cc-msisdn [msisdn]="item.destinationMsisdn"></cc-msisdn>
    <div class="wait-time">{{item.registeredAt | timeFromNow }}</div>
  </div>
</ng-container>
<cc-no-data
  *ngIf="!(results | async)?.length"
></cc-no-data>
